import { render, staticRenderFns } from "./shopStoreGoodsCat.vue?vue&type=template&id=d711d712&"
import script from "./shopStoreGoodsCat.vue?vue&type=script&lang=js&"
export * from "./shopStoreGoodsCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports